<template>
  <QDrawer
    v-model="opened"
    :width="$q.screen.lt.sm ? $q.screen.width : 450"
    no-swipe-open
    no-swipe-close
    no-swipe-backdrop
    side="right"
    behavior="mobile"
    content-class="dashboard-detail-drawer bg-grey-3"
  >
    <!-- Content -->
    <QScrollArea class="fit bg-extra-light-grey">
      <div class="q-pt-xl q-pb-md q-px-md">
        <router-view name="dashboardDrawer" />
      </div>
    </QScrollArea>

    <!-- Header -->
    <QToolbar class="bg-white shadow-soft text-primary header-ios-safe absolute-top">
      <QBtn icon="close" flat round dense @click="$router.go(-1)" />
      <QToolbarTitle>{{ $t(drawerTitle) }}</QToolbarTitle>
    </QToolbar>
  </QDrawer>
</template>

<script>
  import { RouterHelpers } from "@core/helpers";
  import { META_DASHBOARD_DETAIL_OPENED } from "@etab/config";
  import { GETTER_DASHBOARD_TITLE } from "@etab/stores/types";
  import { useDashboardStore } from "@etab/stores/dashboard";
  import { mapStores } from "pinia";

  export default {
    computed: {
      ...mapStores(useDashboardStore),
      opened: {
        get() {
          return RouterHelpers.getRouteMeta(this.$route, META_DASHBOARD_DETAIL_OPENED);
        },
        set(value) {},
      },
      drawerTitle() {
        return this.dashboardStore[GETTER_DASHBOARD_TITLE] || "ETAB.PAGES.PLANNING.@SHIFT_DETAIL_TITLE_PLACEHOLDER";
      },
    },
  };
</script>

<style lang="scss">
  .dashboard-detail-drawer {
    $drawer-header-height: 50px;
  }
</style>
